interface VideoMediaItemProps {
  videoUrl?: string;
}

export function VideoMediaItem({ videoUrl }: VideoMediaItemProps) {
  if (!videoUrl || !videoUrl.length) return null;

  return <a href={videoUrl} target="_blank" rel="noreferrer"></a>;
}
